export default function Hero() {
  return (
    <div className="pointer-events-none absolute inset-0 z-30">
      {/* Bottom-left meta block */}
      <div className="absolute bottom-10 left-8 md:left-12 flex flex-col gap-5 text-white/85">
        <div className="flex items-center gap-2.5">
          <span className="relative flex h-2 w-2 items-center justify-center">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400/70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-white/60">
            Live · v3.2
          </span>
        </div>

        <div className="flex flex-col gap-1">
          <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">
            Index
          </span>
          <span className="font-display text-3xl md:text-4xl leading-none text-white">
            04
            <span className="text-white/35">/12</span>
          </span>
        </div>

        <div className="hidden md:flex h-px w-16 bg-white/25" />

        <div className="hidden md:flex flex-col gap-0.5">
          <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">
            Capture
          </span>
          <span className="font-mono text-[11px] tracking-wider text-white/70">
            40.7128° N · 74.0060° W
          </span>
        </div>
      </div>

      {/* Bottom-right meta block */}
      <div className="absolute bottom-10 right-8 md:right-12 flex flex-col items-end gap-5 text-white/85">
        <div className="flex items-center gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-white/60">
            Scroll
          </span>
          <span className="relative flex h-8 w-[18px] items-start justify-center rounded-full border border-white/40">
            <span className="mt-1.5 h-2 w-px animate-[scrollDot_1.8s_ease-in-out_infinite] bg-white/80" />
          </span>
        </div>

        <div className="hidden md:flex flex-col items-end gap-1">
          <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">
            Frame
          </span>
          <div className="flex items-baseline gap-1.5">
            <span className="font-display text-3xl md:text-4xl leading-none text-white">
              0824
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">
              fps · 120
            </span>
          </div>
        </div>

        <div className="hidden md:flex h-px w-16 bg-white/25" />

        <div className="hidden md:flex flex-col items-end gap-0.5">
          <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">
            Edition
          </span>
          <span className="font-mono text-[11px] tracking-wider text-white/70">
            № 026 · Summer Drop
          </span>
        </div>
      </div>
    </div>
  );
}